







































































































































































































import '@/extensions';
import {
    IErrors,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData, {ErrorsMap} from '@/mixins/local-data';

import {
    ISaleFiltersInLevels,
    ISaleSaveDto,
} from '@/pages/Sales/data';
import moment, { Moment } from 'moment';

import {BModal, BvModalEvent} from 'bootstrap-vue';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Card from '@/components/UI/Card.vue';
import DatePicker from 'vue2-datepicker';
import {isNumber} from "lodash";

@Component({
    methods: {isNumber},
    components: {
        vSelect,
        Card,
        DatePicker
    },
})
export default class CreateSaleModal extends Mixins(LocalData, Http) {
    @Prop({required: true}) readonly filters!: ISaleFiltersInLevels;
    @Prop({required: false, default: false}) readonly disableCreateButton?: boolean;
    @Prop({required: true}) readonly errObj: any;

    @Watch('errObj', {deep: true})
    onErrObjChanged() {
        if (this.errObj) {
            this.handleHttpError(this.errObj);
        } else {
            this.hideFormErrors('saveSale');
        }
    }

    private allOption = {value: -1, label: this.$t('shared.selectBox.all') as string};
    private confirmMessage = '';

    private saleParams: ISaleSaveDto = {
        id: null,
        startDate: new Date().toLocaleDateString('sv-SE'),
        endDate: new Date(((new Date()).setDate((new Date()).getDate() + 14))).toLocaleDateString('sv-SE'),
        name: null,
        type: null,
        stagesNumber: 3,
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minMargin: null,
        revaluationFileName: null,
    };

    private formErrors: ErrorsMap = {};
    private showFormError: boolean = false;
    private ok_only = false;

    private get saveModal(): BModal {
        return this.$refs.saveSaleModal as BModal
    }

    get minMarginValidate(): boolean {
        return !!((!this.saleParams.minMargin && this.saleParams.minMargin !== 0) || ((this.saleParams.minMargin || this.saleParams.minMargin == 0) && this.saleParams.minMargin >= -100 && this.saleParams.minMargin <= 100));
    }

    private confirmAction = () => {
    };

    private cancelAction = () => {
    };

    private createButtonClick() {
        this.saveModal.show();
    }

    private handleCancelClick () {
        this.saveModal.hide();

        this.saleParams = {
            id: null,
            startDate: new Date().toLocaleDateString('sv-SE'),
            endDate: new Date(((new Date()).setDate((new Date()).getDate() + 14))).toLocaleDateString('sv-SE'),
            name: null,
            type: null,
            stagesNumber: 3,
            minSaleDiscount: null,
            maxSaleDiscount: null,
            minMargin: null,
            revaluationFileName: null,
        }
    }

    private onSaveButtonClicked(event: BvModalEvent) {
        event.preventDefault();

        if (Object.keys(this.saleParams).length) {
            const saleParams = Object.assign({}, this.saleParams);

            this.$emit('save-button-clicked', saleParams);
        }
    }

    private setNonNegative(input: string): string {
        const parsed = parseFloat(input);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return `${parsed * -1}`;
        } else {
            return input;
        }
    }

    valueInRange(input: string, fromNumber: number, toNumber: number): number {
        const inputValue = isNaN(parseFloat(input)) ? 0 : parseFloat(input);

        if (inputValue > toNumber) {
            return toNumber;
        } else if (inputValue < fromNumber) {
            return fromNumber;
        } else {
            return inputValue;
        }
    }

    handleMaxSaleDiscountValueChanged() {
        if (this.saleParams.minSaleDiscount && isNumber(this.saleParams.maxSaleDiscount)
            && this.saleParams.maxSaleDiscount < this.saleParams.minSaleDiscount) {
            this.saleParams.minSaleDiscount = this.saleParams.maxSaleDiscount;
        }
    }


    private getMessage(form: string, field: string): string | null {
        if (!this.formErrors.hasOwnProperty(form)) {
            return null;
        }

        if (!this.formErrors[form].hasOwnProperty(field)) {
            return null;
        }
        return this.formErrors[form][field].message;
    }

    private confirmHide() {
        this.confirmMessage = '';
        this.confirmAction = () => {
        };
        this.cancelAction = () => {
        };
    }

    private handleHttpError(err: any) {
        if (err && err.hasOwnProperty('response') && err.response != null) {
            if (err.response.data && err.response.data.errors && err.response.data.errors.length) {
                const errors = err.response.data as IErrors;
                this.renderErrors('saveSale', errors);
            } else if (err.response.data && typeof (err.response.data) === 'string') {
                this.showError(err.response.data);
                this.$log.error('Error occurred while save sale', err);
            } else {
                this.showError(this.$t('salesListTab.createModal.saveError') as string);
                this.$log.error('Error occurred while save sale', err);
            }
        } else {
            this.showError(this.$t('salesListTab.createModal.saveError') as string);
            this.$log.error('Error occurred while save sale', err);
        }
    }

    private renderErrors(form: string, errors: IErrors) {
        this.hideFormErrors(form)
        this.showFormError = true;
        errors.errors.forEach((e) => {
            this.formErrors[form][e.property] = e;
        });
    }

    private hideFormErrors(form: string) {
        this.formErrors[form] = {};
        this.showFormError = false;
    }

    private get allowToSave(): boolean {
        return !!(this.saleParams.name && this.saleParams.type && this.saleParams.startDate && this.saleParams.endDate
            && this.minMarginValidate && (!!this.saleParams.minMargin || this.saleParams.minMargin === 0)
            && (this.saleParams.minSaleDiscount || this.saleParams.minSaleDiscount === 0)
            && (this.saleParams.maxSaleDiscount || this.saleParams.maxSaleDiscount === 0));
    }

    disabledDatepickerDate(current: Moment, data: any, property: string) {
        if (current && current < moment().startOf('day')) return true;

        if (property === 'startDate') {
            if (data.endDate) {
                return current && current > moment(data.endDate).endOf('day')
            }
        }

        if (property === 'endDate') {
            if (data.startDate) {
                return current && current < moment(data.startDate).startOf('day')
            }
        }

        return false;
    }
}
